// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SWR from "rescript-swr/src/SWR.bs.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.mjs";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as API$MakerDs from "maker-ds/src/api/API.bs.mjs";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Abort$FeedSync from "../Abort.bs.mjs";
import * as Clerk$FeedSync from "./Clerk.bs.mjs";
import * as Product$FeedSync from "../models/Product.bs.mjs";
import * as API_Error$MakerDs from "maker-ds/src/api/API_Error.bs.mjs";
import * as Settings$FeedSync from "../Settings.bs.mjs";
import * as API_Result$MakerDs from "maker-ds/src/api/API_Result.bs.mjs";
import * as SnapshotTracker$FeedSync from "../SnapshotTracker.bs.mjs";
import * as BrowserFetchUtil$FeedSync from "../BrowserFetchUtil.bs.mjs";
import * as SnapshotTrackerId$FeedSync from "../SnapshotTrackerId.bs.mjs";

var apiUrl = "";

function getAccountIdFromClerk(param) {
  var clerkOrganization = Clerk$FeedSync.getOrganization(undefined);
  var clerkOrganizationAccountId = Belt_Option.flatMap(clerkOrganization, (function (org) {
          return org.publicMetadata.accountId;
        }));
  if (clerkOrganizationAccountId !== undefined) {
    return clerkOrganizationAccountId;
  } else {
    return Js_exn.raiseError("The backend requested that clerk be used for the account, but no clerk organization was found.");
  }
}

function getAccountId(param) {
  var envUserId = window.ENV.userId;
  if (envUserId == null) {
    return getAccountIdFromClerk(undefined);
  } else {
    return envUserId;
  }
}

async function getSessionToken(param) {
  var envAccessToken = window.ENV.accessToken;
  if (!(envAccessToken == null)) {
    return envAccessToken;
  }
  var session = Belt_Option.flatMap(window.Clerk, (function (prim) {
          return prim.session;
        }));
  var clerkSession = session !== undefined ? Caml_option.valFromOption(session) : Js_exn.raiseError("No session found - unauthorized");
  return await clerkSession.getToken({
                template: "user",
                skipCache: false
              }).then(function (clerkToken) {
              return clerkToken;
            });
}

function serverError_encode(v) {
  return Js_dict.fromArray([[
                "error",
                Decco.stringToJson(v.error)
              ]]);
}

function serverError_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var error = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "error"), null));
  if (error.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              error: error._0
            }
          };
  }
  var e = error._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".error" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function getServerErrorMessage(body) {
  var errorBody = serverError_decode(body);
  if (errorBody.TAG === /* Ok */0) {
    return errorBody._0.error;
  }
  
}

function detectServerSideErrors(res) {
  if (res.statusCode >= 200 && res.statusCode < 300) {
    return {
            TAG: /* Ok */0,
            _0: res
          };
  }
  var responseBodyError = getServerErrorMessage(res.body);
  if (responseBodyError !== undefined) {
    return {
            TAG: /* Error */1,
            _0: API_Error$MakerDs.$$Error.make(responseBodyError, undefined, undefined, undefined)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: API_Error$MakerDs.$$Error.make("Something went wrong. Error " + String(res.statusCode) + " " + Belt_Option.getWithDefault(res.statusText, ""), undefined, undefined, undefined)
          };
  }
}

function apiCall(url, decoder, method_, payload, param) {
  console.log("apicall", url);
  var url$1 = window.ENV.publicUrl + url;
  var jwt = getSessionToken(undefined);
  return API_Result$MakerDs.Result.flatMap(API_Result$MakerDs.Result.flatMap(API_Result$MakerDs.Result.make(jwt.then(function (jwt) {
                          var res = BrowserFetchUtil$FeedSync.$$fetch(url$1, payload, undefined, method_, jwt, undefined, undefined, undefined, undefined);
                          var normalize = function (res) {
                            var status = res.status;
                            var statusText = res.statusText;
                            var body = Js_promise.$$catch((function (param) {
                                    console.warn("could not parse response as JSON - defaulting to null, this may not be an error if the response is ignored");
                                    return Promise.resolve(null);
                                  }), res.json());
                            return body.then(function (body) {
                                        return Promise.resolve({
                                                    statusCode: status,
                                                    statusText: statusText,
                                                    totalResults: undefined,
                                                    body: body
                                                  });
                                      });
                          };
                          return res.then(normalize);
                        })), detectServerSideErrors), decoder);
}

function $$fetch(cache, decoder, url) {
  return API_Result$MakerDs.Result.toPromise(apiCall(url, decoder, undefined, undefined, undefined));
}

function useSettings(param) {
  var url = "" + apiUrl + "/api/get_settings?account_id=" + getAccountId(undefined) + "";
  return SWR.useSWR(undefined, undefined, undefined, undefined, url, (function (param) {
                return $$fetch(undefined, (function (param) {
                              return API$MakerDs.singleton(Settings$FeedSync.fromJson, param);
                            }), param);
              }));
}

function updateSettings(settings) {
  var url = "" + apiUrl + "/api/update_settings?account_id=" + getAccountId(undefined) + "";
  var payload = Settings$FeedSync.toJson(settings);
  return API_Result$MakerDs.Result.map(apiCall(url, API$MakerDs.ignoreResponse, /* Put */3, Caml_option.some(payload), undefined), (function (res) {
                return SWR.revalidate("" + apiUrl + "/api/get_settings?account_id=" + getAccountId(undefined) + "");
              }));
}

function ingest(param) {
  var url = "" + apiUrl + "/api/ingest?account_id=" + getAccountId(undefined) + "";
  return apiCall(url, API$MakerDs.ignoreResponse, /* Post */2, undefined, undefined);
}

function deployLatest(id) {
  var url = "" + apiUrl + "/api/deploy_latest?account_id=" + getAccountId(undefined) + "&tracker_id=" + Curry._1(SnapshotTrackerId$FeedSync.toString, id) + "";
  return API_Result$MakerDs.Result.map(apiCall(url, API$MakerDs.ignoreResponse, /* Post */2, undefined, undefined), (function (res) {
                return SWR.revalidate("" + apiUrl + "/api/get_snapshots?account_id=" + getAccountId(undefined) + "");
              }));
}

function rollback(timestamp) {
  var url = "" + apiUrl + "/api/rollback?timestamp=" + timestamp.toString() + "&account_id=" + getAccountId(undefined) + "";
  return API_Result$MakerDs.Result.map(API_Result$MakerDs.Result.map(apiCall(url, API$MakerDs.ignoreResponse, /* Post */2, undefined, undefined), (function (res) {
                    return SWR.revalidate("" + apiUrl + "/api/get_snapshots?account_id=" + getAccountId(undefined) + "");
                  })), (function (res) {
                return SWR.revalidate("" + apiUrl + "/api/get_settings?account_id=" + getAccountId(undefined) + "");
              }));
}

function killJob(trackerId) {
  var url = "" + apiUrl + "/api/kill_job";
  var payload = Abort$FeedSync.toJson({
        trackerId: trackerId
      });
  return API_Result$MakerDs.Result.map(apiCall(url, (function (param) {
                    return API$MakerDs.singleton(SnapshotTracker$FeedSync.fromJson, param);
                  }), /* Post */2, Caml_option.some(payload), undefined), (function (res) {
                return SWR.revalidate("" + apiUrl + "/api/get_snapshots?account_id=" + getAccountId(undefined) + "");
              }));
}

function useSnapshotHistory(param) {
  var url = "" + apiUrl + "/api/get_snapshots?account_id=" + getAccountId(undefined) + "";
  return SWR.useSWR(undefined, 1000, undefined, undefined, url, (function (param) {
                return $$fetch(undefined, (function (param) {
                              return API$MakerDs.singleton(SnapshotTracker$FeedSync.$$Array.fromJson, param);
                            }), param);
              }));
}

function useRawData(q, timestamp, currency, staticCacheOnly) {
  var getKey = function (pageNum, prevPage) {
    var cursor = Belt_Option.flatMap((prevPage == null) ? undefined : Caml_option.some(prevPage), (function (page) {
            return page.next;
          }));
    return "" + apiUrl + "/api/raw_search?account_id=" + getAccountId(undefined) + "&q=" + encodeURIComponent(q) + "&timestamp=" + timestamp.toString() + "&currency=" + currency + "&static_cache_only=" + (
            staticCacheOnly ? "true" : "false"
          ) + "" + Belt_Option.mapWithDefault(cursor, "", (function (cursor) {
                  return "&cursor=" + cursor + "";
                })) + "";
  };
  return SWR.useSWRInfinite(undefined, undefined, undefined, undefined, undefined, undefined, undefined, getKey, (function (param) {
                return $$fetch(undefined, (function (param) {
                              return API$MakerDs.singleton(Product$FeedSync.Validated.Result.Page.fromJson, param);
                            }), param);
              }));
}

export {
  apiUrl ,
  getAccountIdFromClerk ,
  getAccountId ,
  getSessionToken ,
  serverError_encode ,
  serverError_decode ,
  getServerErrorMessage ,
  detectServerSideErrors ,
  apiCall ,
  $$fetch ,
  useSettings ,
  updateSettings ,
  ingest ,
  deployLatest ,
  rollback ,
  killJob ,
  useSnapshotHistory ,
  useRawData ,
}
/* SWR Not a pure module */
